import React from 'react';
import {
    availableFontSizes,
    availableFontStyle,
    availableTextAlign,
    availableTextDecoration,
    availableLineHeight
} from '../../constants/availableFonts';

const carouselStoreDefaults = {
    availableFontSizes: availableFontSizes,
    availableFontStyle: availableFontStyle,
    availableTextDecoration: availableTextDecoration,
    availableLineHeight: availableLineHeight,
    availableTextAlign: availableTextAlign
};

const carouselReducer = (state = carouselStoreDefaults, action) => {
    return state;
};

export default carouselReducer;



// WEBPACK FOOTER //
// ./src/reducers/theme/carousel.js